// extracted by mini-css-extract-plugin
export var leftAlign = "_2f-2";
export var popper = "_2f-0";
export var subtitle = "_2f-1";